import React from 'react';
import { useSelector } from 'react-redux';

import useFlushStagedPicks from 'lib/hooks/useFlushStagedPicks';
import { getMaterialPickingEnabled } from 'lib/selectors/getMaterialPickingEnabled';

const Flusher = () => {
  useFlushStagedPicks();
  return null;
};

// Renders nothing: writes material picks staged at job start once the job is
// confirmed running (see useFlushStagedPicks). Mounted once per machine page; the
// hook only mounts where material picking is enabled.
const StagedPicksFlusher = () => {
  const materialPickingEnabled = useSelector(getMaterialPickingEnabled);
  return materialPickingEnabled ? <Flusher /> : null;
};

export default StagedPicksFlusher;
